/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="#BABABA"
      {...props}
      data-palette="ArrowRight">
      <path
        d="M2.121 4.773L5.8335 1.0605L4.773 0L-3.8147e-06 4.773L4.773 9.546L5.8335 8.4855L2.121 4.773Z"
        fill="currentColor"
      />
    </svg>)
  );
};

export default ArrowRight;
